import {
  P0,
  S,
  abs,
  arc,
  fillAt,
  max,
  min,
  quad,
  rotPts,
} from '../../geometry';

export const fox = {
  name: 'Fox',
  colors: ['#C46A3E', '#E3A008'],
  draw(m, t) {
    let eL = [26, 16],
      eR = [74, 16],
      sw = 5 * S(t * 1.5),
      cu = 0,
      W = 7.5,
      pose = P0();
    if (m === 'happy') {
      eL = [25, 13];
      eR = [75, 13];
      sw = -6 + 16 * S(t * 11);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the brush tail keeps sweeping a big slow arc while the ears take turns flicking.
    if (m === 'thinking') {
      sw = -4 + 26 * S(t * 1.7);
      cu = 8 * S(t * 1.7 - 1);
      const fl = max(0, S(t * 2.6)),
        fr = max(0, -S(t * 2.6));
      eL = [26 - 6 * fl, 16 + 7 * fl];
      eR = [74 + 6 * fr, 16 + 7 * fr];
      pose.rot = 3 * S(t * 1.3);
    }
    if (m === 'talking') {
      eL = [26, 16 + 2.5 * max(0, S(t * 10))];
      eR = [74, 16 + 2.5 * max(0, S(t * 10 + 1.5))];
      sw = 8 * S(t * 5);
    }
    if (m === 'surprised') {
      eL = [24, 8];
      eR = [76, 8];
      sw = -22 + 2 * S(t * 26);
      cu = -6;
      W = 9;
      pose.ty = -2;
    }
    if (m === 'paused') {
      eL = [19, 27];
      eR = [81, 27];
      sw = 62 + 2 * S(t * 0.8);
      cu = 6;
      pose.ty = 2;
      pose.sy = 0.95;
    }
    const base = [64, 74],
      [c1, tip] = rotPts(
        [
          [92 + cu, 76],
          [86 + cu, 46],
        ],
        base[0],
        base[1],
        sw
      );
    const mid = quad(base, c1, tip, 10),
      side = (sg) =>
        mid.map((p, k) => {
          const q = mid[min(9, k + 1)],
            o = mid[max(0, k - 1)],
            dx = q[0] - o[0],
            dy = q[1] - o[1],
            d = Math.hypot(dx, dy) || 1,
            w = W * S(Math.PI * min(1, 0.3 + (0.7 * k) / 9));
          return [p[0] - (dy / d) * w * sg, p[1] + (dx / d) * w * sg];
        });
    const head = [
      [27, 46],
      eL,
      [40, 34],
      [60, 34],
      eR,
      [73, 46],
      [71, 60],
      [50, 77],
      [29, 60],
      [27, 46],
    ];
    return {
      strokes: [
        { c: 'b', pts: [...side(1), ...side(-1).reverse(), side(1)[0]], n: 30 },
        { c: 'a', pts: head, sharp: true, n: 72 },
      ],
      eyes: { x: 50, y: 51 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1),
};
